<template>
  <div class="m-gallery-details__columns">
    <div class="m-gallery-details__column">
      <GalleryMap :gallery="gallery" />
    </div>
    <div class="m-gallery-details__column">
      <!-- gallery details column -->
      <GalleryDescription :gallery="gallery" />
    </div>
  </div>
</template>

<script>
import GalleryDescription from "@/components/atoms/galleryDescription/index.vue";
import { localizationMixin } from "@thegetty-private/getty-ui";
import GalleryMap from "@/components/atoms/galleryMap/index.vue";

export default {
  name: "GalleryDetails",
  components: { GalleryDescription, GalleryMap },
  mixins: [localizationMixin],
  props: {
    /**
     * The gallery object's LOD
     */
    gallery: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss">
@import "./index.scss";
</style>
